/**
 * Creates a new instance of an array and appends the provided item
 * @param items Array of items to supplement
 * @param newItem Item to add to the array
 * @returns A new array instance containing the newly added item
 */
export const addToArray = <T extends { _id: string }>(items: T[], newItem: T) => [...items, newItem];

/**
 * Replaces an item in a new instance of the provided array, predicated by the _id property
 * @param items Array of items to update
 * @param newItem New copy of the object to update, must contain the same _id property
 * @returns A new array instance containing the newly updated item
 */
export const updateInArray = <T extends { _id: string }>(items: T[], newItem: T) =>
  items.map(item => (item._id === newItem._id ? { ...item, ...newItem } : item));

/**
 * Filters an item out of an array using the _id property of said item
 * @param items Array of items to filter
 * @param idToRemove _id property used to filter out the unwanted item
 * @returns A new array instance omitting the provided item reference
 */
export const removeFromArray = <T extends { _id: string }>(items: T[], idToRemove: string) => items.filter(item => item._id !== idToRemove);
